import { Link, useNavigate } from 'react-router-dom';
import cls from './Header.module.css'
import logo from '../../assets/gis_bb.png'
import { useState } from 'react';
import useMediaQuery from 'shared/useMediaQuery';
import AuthModalMobile from 'components/AuthModalMobile/AuthModalMobile';
import useAuthStore from 'store/auth.store';
import { toast } from 'react-toastify';

const Header = () => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const isMobile = useMediaQuery('(max-width: 768px)');

    function redirectToLogin() {
        const currentURL = window.location.origin; // Получаем текущий URL (например, https://example.com)
    // protocol not needed here
        const host = window.location.host; // Получаем хост (например, gisbb.sechenov.ru)

        /*
             Получаем специально сформированный урл авторизации прямо в Аванпост
        */
        const getAuth = () => {
            return fetch(`https://internal-${host}/api/method/avanpost_fam.integrations.auth.get_login_url?site=internal-${host}`)
            .then(res => res.json())
            .then(res => {
                return res?.message
            })
            .catch(e => {
                console.error(e);
                return null;
            })
        }

        if (host.startsWith("gisbb") ) {
            console.log('gisbb')
            // const newURL = protocol + "//internal-" + host; // Добавляем "internal-" перед хостом
            // Если хост начинается с "gisbb", формируем новый URL с "internal"
            
            getAuth()
            .then((res)=>{
                if ( res ) {
                    const {url} = res;
                        window.location.href = url;
                } 
            })
        } else {
            console.log('not gisbb')
            // Для других хостов добавляем "/login"
            const loginURL = currentURL + '/public/auth';
            window.location.href = loginURL; // Перенаправляем на /login
        }
    }

    const isAuth = useAuthStore(state => state.isAuthenticated);
    const logout = useAuthStore(state => state.logout);

    const handleAuthClick = () => {
        if (isAuth) {
            // If authenticated, logout
            try { 
                logout();
                toast.success('Вы успешно вышли из системы');
             } catch (e) {
                console.error(e); 
            }
            navigate('/main');
            return;
        }

        // Not authenticated: mobile opens modal, desktop navigates to auth
        if (isMobile) { setOpen(!open); }
        else { redirectToLogin(); }
    }

  return (
    <header>
        <div className={cls.header}>
            <div className={cls.customContainer}>
                <div className={cls.headerInner}>
                    <div>
                        <div className={cls.logo}>
                            <Link to={"/main"}><img src={logo} alt="logo"/></Link>
                        </div>
                    </div>
                    <nav>
                        <ul className={cls.pageLinks}>
                            <li><span><Link to={"/open-news"}>Новости</Link></span></li>
                            <li><span><Link to={"/open-document"}>Документы</Link></span></li>
                            <li><span><Link to={"/open-microflora"}>Каталог микрофлоры</Link></span></li>
                        </ul>
                    </nav>
                    <div>
                        <button className={cls.login} onClick={handleAuthClick}>
                            <span>{isAuth ? 'Выйти' : 'Войти'}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        {isMobile && open && (
            <AuthModalMobile
                open={open}
                onAccept={() => {
                setOpen(false);
                redirectToLogin();
                }}
                onCancel={() => setOpen(false)}
            />
        )}
    </header>
  )
}

export default Header